@if (displayType === 'input') {
    <div class="filter-field-wrapper range-date-picker-field">
        <mat-form-field [appearance]="appearance" [floatLabel]="floatLabel" [class]="fieldClass" (click)="openMenu()">
            <mat-label>{{ label | translate }}</mat-label>
            <input matInput readonly
                   class="range-date-picker-input"
                   [disabled]="disabled"
                   [value]="display ? (display.key ? (display.key | translate: display.params) : display.text) : ''">
            <!-- Як mat-datepicker-toggle: клік по іконці не спливає до батьківських елементів -->
            <button matSuffix type="button" class="range-date-picker-toggle"
                    [disabled]="disabled"
                    (click)="$event.stopPropagation(); openMenu()">
                <mat-icon>date_range</mat-icon>
            </button>
        </mat-form-field>
        <!-- Невидимий якір меню на всю ширину поля, щоб меню відкривалося під полем -->
        <div class="range-date-picker-anchor"
             [matMenuTriggerFor]="periodsMenu"
             (menuOpened)="onMenuOpened()"
             (menuClosed)="onMenuClosed()"></div>
        @if (clearable && hasValue && !disabled) {
            <button type="button" class="clear-button clear-field" (click)="clear()">
                <mat-icon>close</mat-icon>
            </button>
        }
    </div>
} @else {
    <button type="button"
            class="button-form-field"
            [ngClass]="hasValue ? 'green' : 'gray'"
            [disabled]="disabled"
            [matMenuTriggerFor]="periodsMenu"
            (menuOpened)="onMenuOpened()"
            (menuClosed)="onMenuClosed()">
        <mat-icon class="button-form-field-icon">date_range</mat-icon>
    </button>
}

<mat-menu #periodsMenu="matMenu" class="date-range-picker-menu">
    <!-- Меню закривається лише після вибору періоду, а не від кліку по будь-якому місцю панелі -->
    <div class="period-picker df-c gap10" (click)="$event.stopPropagation()">
        <div class="period-picker-years df jc-sb ai-c">
            <button type="button" class="period-picker-year-button" [disabled]="!canPrevYear" (click)="changeYear(-1)">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="period-picker-year">{{ year }}</span>
            <button type="button" class="period-picker-year-button" [disabled]="!canNextYear" (click)="changeYear(1)">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <div class="period-picker-wrapper df ai-s gap10">
            <div class="period-picker-grid months">
                @for (period of months; track period.label) {
                    <ng-container *ngTemplateOutlet="periodButton; context: {$implicit: period}"></ng-container>
                }
            </div>

            @if (showLongPeriods) {
                <div class="period-picker-grid long-periods">
                    @for (period of longPeriods; track period.label) {
                        <ng-container *ngTemplateOutlet="periodButton; context: {$implicit: period}"></ng-container>
                    }
                </div>
            }
        </div>
    </div>
</mat-menu>

<ng-template #periodButton let-period>
    <button type="button"
            class="period-picker-button"
            [class.selected]="isSelected(period)"
            [disabled]="period.disabled"
            (click)="selectPeriod(period)">
        {{ period.label | translate }}
    </button>
</ng-template>
